import { render } from "./loaderApp.vue?vue&type=template&id=3da3e4d8&scoped=true&lang=html"
import script from "./loaderApp.vue?vue&type=script&lang=js"
export * from "./loaderApp.vue?vue&type=script&lang=js"

import "./loaderApp.vue?vue&type=style&index=0&id=3da3e4d8&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da3e4d8"]])

export default __exports__